var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _vm.userPermissions.indexOf("add_location_departments") > -1
        ? _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-header-top-container" }, [
              _c("div", { staticClass: "page-name" }, [
                _vm._v("Department List")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary waves-effect pull-right",
                  attrs: { type: "submit" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addDepartment.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("Add")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _c(
                "div",
                { staticClass: "app-filter-good-table-container" },
                [
                  _c(
                    "vue-good-table",
                    {
                      ref: "DepartmentList",
                      attrs: {
                        mode: "remote",
                        title: "Department List",
                        totalRows: _vm.totalRecords,
                        columns: _vm.columns,
                        rows: _vm.rows,
                        "pagination-options": {
                          enabled: true,
                          mode: "pages",
                          pageLabel: "Page",
                          position: "bottom",
                          perPage: _vm.serverParams.perPage,
                          perPageDropdown: [25, 50, 100, 200, 500],
                          dropdownAllowAll: false
                        },
                        "select-options": {
                          enabled: true,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: "custom-class",
                          selectionText: "rows selected",
                          clearSelectionText: "Clear"
                        },
                        "search-options": {
                          enabled: false
                        }
                      },
                      on: {
                        "on-page-change": _vm.onPageChange,
                        "on-selected-rows-change": _vm.selectionChanged,
                        "on-column-filter": _vm.onColumnFilter,
                        "on-per-page-change": _vm.onPerPageChange,
                        "on-sort-change": _vm.onSortChange
                      },
                      scopedSlots: _vm._u(
                        [
                          _vm._l(_vm.rows, function(row, key) {
                            return {
                              key: "table-row",
                              fn: function(props) {
                                return [
                                  _c("div", { key: key }, [
                                    props.column.field == "action"
                                      ? _c(
                                          "div",
                                          { staticClass: "table-action" },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "btn edit-btn-vvg waves-effect pull-left",
                                                attrs: {
                                                  title: "Edit Department",
                                                  to: {
                                                    name: "UpdateDepartment",
                                                    params: { id: props.row.id }
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-pencil",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            props.row.departmentIsActive == 1
                                              ? [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn edit-btn-vvg waves-effect pull-left manageicon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.activeOrInactiveState(
                                                            props.row.id,
                                                            "inactive"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-eye-slash",
                                                        attrs: {
                                                          title:
                                                            "make inactive",
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn edit-btn-vvg waves-effect pull-left manageicon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.activeOrInactiveState(
                                                            props.row.id,
                                                            "active"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-eye",
                                                        attrs: {
                                                          title: "make active",
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                props.formattedRow[
                                                  props.column.field
                                                ]
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                  ])
                                ]
                              }
                            }
                          })
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          attrs: { slot: "selected-row-actions" },
                          slot: "selected-row-actions"
                        },
                        [
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-success waves-effect row-deactivate-btn",
                                attrs: { id: "deleteGroupBtn" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.activeOrInactiveState(
                                      0,
                                      "inactive"
                                    )
                                  }
                                }
                              },
                              [_vm._v("Deactivate")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-success waves-effect row-activate-btn",
                                attrs: { id: "deleteGroupBtn" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.activeOrInactiveState(
                                      0,
                                      "active"
                                    )
                                  }
                                }
                              },
                              [_vm._v("Activate")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-success waves-effect row-activate-btn",
                                attrs: { id: "deleteGroupBtn" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.deleteDepartment(0)
                                  }
                                }
                              },
                              [_vm._v("Delete")]
                            )
                          ]
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        : _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-name" }, [
              _vm._v("\n            Oops...!\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _vm._v(
                "\n            Sorry, You don't have permission to access this page.\n        "
              )
            ])
          ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85220a1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85220a1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/ManageDepartments/DepartmentsList.vue
// module id = null
// module chunks = 